import { HttpErrorResponse } from '@angular/common/http';

/**
 * Determines whether this response is specifically an **access JWT** failure
 * (middleware) vs RBAC denial (Shield code 1004).
 * We must NOT attempt token refresh when the token is valid but permissions are insufficient.
 */
export function httpErrorIndicatesJwtAuthFailure(
  error: HttpErrorResponse | undefined,
): boolean {
  if (!error || (error.status !== 401 && error.status !== 403)) {
    return false;
  }
  const e = error.error as Record<string, unknown> | string | null | undefined;
  if (typeof e === 'string') {
    return /invalid or expired token|access token is required/i.test(e);
  }
  if (!e || typeof e !== 'object') {
    return error.status === 401;
  }
  const code = (e as { code?: unknown }).code;
  if (code === 1004 || code === '1004') {
    return false;
  }
  const json = JSON.stringify(e).toLowerCase();
  const tokenSignals =
    /invalid or expired token|access token is required/.test(json) ||
    (e as { error?: string }).error === 'Invalid or expired token.' ||
    (typeof (e as { error?: string }).error === 'string' &&
      /invalid or expired/i.test(String((e as { error?: string }).error)));
  if (tokenSignals) return true;
  /** 401 is almost never used for RBAC here; assume token/session. */
  return error.status === 401 && code !== 1004;
}
